// extracted by mini-css-extract-plugin
export default {"modal":"ModalMakeOffer_modal__C3eAU","modalCtaStyle":"ModalMakeOffer_modalCtaStyle__Ybd4D","button":"ModalMakeOffer_button__cVmTY","icon":"ModalMakeOffer_icon__MFLxe"};